"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("../../../styles/2_commonComponentStyles/button");

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _Button = require("./Button.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Button component encapsulates our standard button look and feel.
 * All standard buttons have the same disabled state.
 * This is to make it immediately clear when an action cannot be performed.
 */
var Button = function Button(_ref) {
  var children = _ref.children,
      iconName = _ref.iconName,
      props = _objectWithoutProperties(_ref, ["children", "iconName"]);

  return /*#__PURE__*/_react.default.createElement(_Button.StyledProtoButton, props, iconName !== '' && /*#__PURE__*/_react.default.createElement(_Button.StyledIcon, {
    dataTestId: "button-icon",
    iconName: iconName,
    inheritColor: true
  }), children);
};

Button.propTypes = {
  /** Used to set an active view state via props, resulting in the button appearing in its 'active' state - used primarily for IconBubbleButtons */
  active: _propTypes.default.bool,

  /** Height options for when we need something other than our rather large default button */
  buttonHeight: _propTypes.default.oneOf([undefined, 'small', 'medium', 'large']),

  /** Width options to support button sizes that are NOT 100% of their parent */
  buttonWidth: _propTypes.default.oneOf([undefined, 'fitText', 'small', 'medium', 'large']),

  /** Button Type - can leave as the default unless you are doing a form submission button */
  buttonType: _propTypes.default.string,

  /** Any node(s) that are valid children of an HTML button */
  children: _propTypes2.default.children.isRequired,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Used to pick the color theme to apply to the button - One of:
   * undefined,
   'primary',
   'cta',
   'overDark',
   */
  colorTheme: _propTypes.default.oneOf(_button.buttonColorThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Debounce threshold.  Set to 0 (zero) to disable. */
  debounceThreshold: _propTypes.default.number,

  /** Flag to disable the button, impacting visibility and click-ability */
  disabled: _propTypes.default.bool,

  /** Name of icon to display on button */
  iconName: _propTypes.default.string,
  // EVENTS

  /** Function to invoke upon being clicked */
  onClick: _propTypes.default.func
};
Button.defaultProps = {
  active: false,
  buttonHeight: undefined,
  buttonWidth: undefined,
  buttonType: 'button',
  colorTheme: 'primary',
  className: '',
  debounceThreshold: 500,
  disabled: false,
  iconName: '',
  onClick: function onClick() {}
};
var _default = Button;
exports.default = _default;